import { render, staticRenderFns } from "./AMSFloatTable.vue?vue&type=template&id=391f179a&scoped=true&"
import script from "./AMSFloatTable.vue?vue&type=script&lang=ts&"
export * from "./AMSFloatTable.vue?vue&type=script&lang=ts&"
import style0 from "./AMSFloatTable.vue?vue&type=style&index=0&id=391f179a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391f179a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VIcon})
